// start:ng42.barrel
export * from './loading-indicator.component';
export * from './loading-indicator.module';
// end:ng42.barrel
